import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState } from '@y42/angular/util';
import { DateTimeService } from '@y42/date-time';
import { AbstractJobService } from '@y42/job';
import { BehaviorSubject, from, map, shareReplay, tap } from 'rxjs';

export interface OrchestrationNodeLogsDialogData {
  jobId: string;
  path: string;
}

@UntilDestroy()
@Component({
  selector: 'y42-orchestration-node-logs-dialog',
  templateUrl: './orchestration-node-logs-dialog.component.html',
  styleUrls: ['./orchestration-node-logs-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrchestrationNodeLogsDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<OrchestrationNodeLogsDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    private readonly data: OrchestrationNodeLogsDialogData,
    private readonly jobService: AbstractJobService,
    private readonly dateTimeService: DateTimeService,
  ) {}

  private readonly loadingJob$$ = new BehaviorSubject(true);

  private readonly job$ = from(this.jobService.getJob(this.data.jobId, this.data.path)).pipe(
    tap(() => this.loadingJob$$.next(false)),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  readonly state = connectState(this, {
    job: this.job$,
    event_id: this.job$.pipe(
      map((job) => {
        if (job?.request.event_id) {
          return job.request.event_id;
        } else if (job?.request.job_id) {
          return `${this.dateTimeService.__format(new Date(job.created_at), 'yyMMddHHmmss', true)}_${
            job.request.job_id
          }`;
        }
        return undefined;
      }),
    ),
    loadingJob: this.loadingJob$$,
  });

  cancel() {
    this.dialogRef.close();
  }
}
